// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryTabs_container__CQOTV","btn":"CategoryTabs_btn__5Mnhl","dead":"CategoryTabs_dead__suqpo"};